/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

const RATINGS_TYPES = {
	LIKE: 'like',
	STACKED_STARS: 'stacked-stars',
	STARS: 'stars',
	THUMBS: 'thumbs',
};

export default RATINGS_TYPES;
